import axios from "axios";

export const userModule = {
  namespaced: true,
  state: {
      isLoading: true,
      userFullName: '',
      userName: '',
    userId: -1,
      resourceId: -1,
      isSubcontractorAdmin: false,
    isCustomerAdmin: false,
    isAdmin: false,
    isCallcenter: false,
    allowedFileExtensions: []
  },
  actions: {
    getCurrentUser({ commit }) {
      axios.get(process.env.VUE_APP_ROOT_API + `User/GetCurrentUserDetails`, { withCredentials: true })
        .then(response => {
          commit('SET_CURRENT_USER', response.data);
        })
        .catch(error => console.log(error));
    }
  },
  mutations: {
    'SET_CURRENT_USER'(state, user) {
          state.userFullName = user.Name;
          state.userId = user.UserId;
          state.userName = user.UserName;
          state.isSubcontractorAdmin = user.IsSubcontractorAdmin;
          state.isCustomerAdmin = user.IsCustomerAdmin;
          state.isAdmin = user.IsAdmin;
          state.isCallcenter = user.IsCallcenter;
          state.resourceId = user.ResourceId;
          state.allowedFileExtensions = user.AllowedFileExtensions;
          state.isLoading = false;
    }
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    }
  }
};
